import { render, staticRenderFns } from "./Avis.vue?vue&type=template&id=eef30b76&"
import script from "./Avis.vue?vue&type=script&lang=js&"
export * from "./Avis.vue?vue&type=script&lang=js&"
import style0 from "./Avis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports